import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Message, Icon } from 'semantic-ui-react';
import './Notification.css';

export default class Notification extends Component {
  static propTypes = {
    notification: PropTypes.obj,
    dismissNotification: PropTypes.func
  }

  render() {
    if (!this.props.notification)
      return (<div />);
    if (this.props.notification.type === 'loading')
      return (
        <Message className="Notification" icon onDismiss={this.props.dismissNotification}>
          <Icon name='circle notched' loading />
          <Message.Content>
            <Message.Header>{this.props.notification.title ? this.props.notification.title : 'Just one second'}</Message.Header>
            {this.props.notification.message}
          </Message.Content>
        </Message>
      );
    if (this.props.notification.type === 'success')
      return (
        <Message className="Notification" icon positive onDismiss={this.props.dismissNotification}>
          <Icon name='check circle' />
            <Message.Content>
          <Message.Header>{this.props.notification.title ? this.props.notification.title : 'Success!'}</Message.Header>
          {this.props.notification.message}
            </Message.Content>
        </Message>
      );
    if (this.props.notification.type === 'error')
      return (
        <Message className="Notification" icon  negative onDismiss={this.props.dismissNotification}>
            <Icon name='remove circle' />
            <Message.Content>
          <Message.Header>{this.props.notification.title ? this.props.notification.title : 'Something Wrong!'}</Message.Header>
          {this.props.notification.message}
            </Message.Content>
        </Message>
      );
  }
}



// WEBPACK FOOTER //
// ./src/components/NotificationComponent/Notification.js